import { render, staticRenderFns } from "./SFormProductComp.vue?vue&type=template&id=7c0de254&"
import script from "./SFormProductComp.vue?vue&type=script&lang=js&"
export * from "./SFormProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports